import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ChangeDetectionStrategy, EventEmitter, Input, Output, ViewChild, ViewEncapsulation, SimpleChanges, OnChanges } from '@angular/core';
import { Component, OnInit, HostListener, ElementRef  } from '@angular/core';

@Component({
    selector: 'select-box',
    templateUrl: './select-box.component.html',
    styleUrls: ['./select-box.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SelectBoxComponent implements OnInit, OnChanges {
  @Input() useRefreshedUi : boolean = false;

  @Input() options: { val: string; checked: boolean }[] = [];
  @Input() title: string = "";
  @Input() type: string = "checkbox"; //input type, checkbox or radio

  @Input() selectedOptions: string[] = [];
  @Output() selectedOptionsChange: EventEmitter<string[]> = new EventEmitter<string[]>();

  @Output() updateSelectedOptions:EventEmitter<string> = new EventEmitter<string>();

  @ViewChild(CdkVirtualScrollViewport) virtualScroll!: CdkVirtualScrollViewport;

  show: boolean = false;

  searchList: { val: string; checked: boolean }[] = [];
  defaultList: { val: string; checked: boolean }[] = [];

  input: any;

  isSelectAllChecked: boolean = false;

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.defaultList = this.options.map(o => ({val:o.val, checked:o.checked}));
    this.searchList = this.defaultList;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options'] && !changes['options'].firstChange) {
      this.defaultList = this.options.map(o => ({val:o.val, checked:o.checked})) ?? [];
      this.searchList = this.defaultList;
    }
  }

  //TODO consider making into a pipe.
  /**
   * Takes a camelCase string and transforms it into a more readable format by 
   * adding spaces between words (capital letters) and capitalizing the first letter (word) of the string.
   * @param title The title string to transform.
   * @returns The transformed title string with spaces before capital letters and the first letter capitalized.
   */
  transformTitle(title: string): string {
    return title.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, str => str.toUpperCase());
  }

  onInput() {
    this.searchList = this.defaultList.filter((x) =>
      x.val.toLocaleLowerCase().includes(this.input.toLocaleLowerCase())
    );
  }

  resetSearch(): void {
    this.input = '';
    this.searchList = this.defaultList;
  }

  toggleSelectOptions() {
    this.show = !this.show;
    if (!this.show) this.resetSearch();
  }

  selectOption(option: { val: string; checked: boolean }) {
    option.checked = !option.checked; //toggle option
    if(this.type=='radio') {
      //need to deselect all options except the selected option in default list
      this.defaultList.forEach((o) => {if(o.val!== option.val) o.checked=false ;});
      if(option.checked) {
        this.selectedOptions = [option.val];
      } else {
        this.selectedOptions = [];
      }
    }
    else{     //if the input type is 'checkbox', then we can select multiple options
      if (option.checked)
        this.selectedOptions.push(option.val);
      else {
        const index = this.selectedOptions.findIndex(
          (selectedOption: any) => selectedOption === option.val
        );
        if (index !== -1)
          this.selectedOptions.splice(index, 1);
        // Update the isSelectAllChecked state based on the current selection
        if(this.selectedOptions.length == this.defaultList.length) {
          this.isSelectAllChecked=true;
        } else {
          this.isSelectAllChecked = false;
        }
      }
    }

    this.emitUpdates();
  }


  @HostListener('document:mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.show=false;
      this.resetSearch();
    }
  }

  updateSelectionFromCheckbox(event: Event) {
    if (this.isSelectAllChecked) {
      this.selectAllOptions();
    } else {
      this.clearAllOptions();
    }
  }

  private selectAllOptions() {
    this.isSelectAllChecked=true;
    this.defaultList.forEach(option => option.checked = true);
    this.selectedOptions = this.defaultList.map(option => option.val);
    this.emitUpdates();
  }
  clearAllOptions() {
    this.isSelectAllChecked=false;
    this.defaultList.forEach(option => option.checked = false);
    this.selectedOptions = [];
    this.emitUpdates();
  }

  private emitUpdates(){
    this.selectedOptionsChange.emit(this.selectedOptions);
    this.updateSelectedOptions.emit(this.title);
  }
}
